@if (hasValidToken) {
  <cw-header>
    <div slot="start" class="header-start-content">
      <div class="d-flex align-items-center">
        @if (routerFacade.isReplenishmentSignal()) {
          <mat-icon class="mr-xs d-flex align-items-center justify-content-center large-icon" svgIcon="app_icon" />
          <!--Dev note: Next line is non-translatable-->
          <span class="app-name-heading">{{ REPLENISHMENT }}</span>
        }
        @if (routerFacade.isRepEvolutionSignal()) {
          <mat-icon class="mr-xs d-flex align-items-center justify-content-center large-icon" svgIcon="app_icon" />
          <!--Dev note: Next line is non-translatable-->
          <span class="app-name-heading">{{ REP_EVOLUTION }}</span>
        }
      </div>
    </div>

    <div slot="end" class="d-flex header-end-content">
      @let showAppSwitch = (
        (routerFacade.isReplenishmentSignal() && userConfigsFacade.hasRepEvolutionAccessSignal()) ||
        (routerFacade.isRepEvolutionSignal() && userConfigsFacade.hasReplenishmentAccessSignal())
      );
      @if (routerFacade.isReplenishmentSignal()) {
        @if (userConfigsFacade.canSwitchViewSignal()) {
          <app-header-view-switch/>
        }
        <app-header-notifications/>
      }
      @if (showAppSwitch) {
        <app-header-app-switch/>
      }
      <app-header-profile />
    </div>
  </cw-header>
}

@if (showSplashScreen) {
  <cw-splash-screen
    *transloco="let t"
    [appName]="t(splashScreenText)">
    <div slot='application-icon'>
      <mat-icon class="splash-screen-icon mt-l d-flex align-items-center justify-content-center" svgIcon="app_icon" />
    </div>
  </cw-splash-screen>
}

<div class="app-shell">
  @if (routerFacade.isReplenishmentSignal()) {
    @if (userConfigsFacade.isExternalViewSignal()) {
      <app-navigation-external/>
    }
    @if (userConfigsFacade.isInternalViewSignal()) {
      <app-navigation-internal/>
    }
  }
  @if (routerFacade.isRepEvolutionSignal()) {
    <app-repevo-navigation/>
  }
  <div class="main-content-container">
    <router-outlet/>

    @if (noAccessReason === NoAccessReasons.MISSING_PERMISSIONS) {
      <app-access-missing-permissions/>
    }

    @if (noAccessReason === NoAccessReasons.LOGIN_ERROR) {
      <app-access-error/>
    }

  </div>
</div>

<app-country-switch-sidebar/>
<app-switch-view-sidebar/>
<app-switch-external-user-sidebar/>
